import { array } from 'prop-types';
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { toast } from 'react-toastify';
import { ABOUT_US, CATEGORY, SOURCE } from '../config/apiEndPoint';
import { GET, POST, PUT } from 'config/api.config';

export const getSourceList = async (data = array()) => {
    try {
        let url = data?._Id ? `${SOURCE.GET_SOURCE_LIST}/${data?._Id}` : `${SOURCE.GET_SOURCE_LIST}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(response.message);
        // console.log(error);
    }
};

export const addSource = async (data = array()) => {
    try {
        const response = await POST(SOURCE.ADD_SOURCE, data);
        return response;
    } catch (error) {
        toast.error(error.message);
    }
};

export const updateSource = async (id, data = array()) => {
    try {
        // in api end point page there have a contact us object where mentioned the end point of api
        const url = `${SOURCE.ADD_SOURCE}/${id}`;
        const response = await PUT(url, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const getSourceDataById = async (data = array()) => {
    try {
        let url = data?.Id ? `${SOURCE.GET_SOURCE_LIST}/${data?.Id}` : `${CATEGORY.GET_CATEGORY_LIST}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(response.message);
        // console.log(error);
    }
};

export const fetchSourceTableAndFilterSchema = async (data = array()) => {
    try {
        let url = data?._Id ? `${SOURCE.GET_JOB_SOURCE_SCHEMA}/${data?._Id}` : `${SOURCE.GET_JOB_SOURCE_SCHEMA}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(response.message);
        // console.log(error);
    }
};

export const submitFilterData = async (data = array()) => {
    try {
        const response = await POST(SOURCE.SUBMIT_FILTER_DATA, data);
        return response;
    } catch (error) {
        toast.error(error.message);
    }
};

